import axios from 'axios';

export default class TimesheetService {
  async getTableData(url, data, method) {
    const response = await axios({
      method,
      url,
      withCredentials: true,
      data,
    }).catch((error) => {
      console.log('getTableData, timesheet', error);
      throw error;
    });
    return response.data;
  }
}
